import React from 'react';
import './TrustSection.css';

/**
 * TrustSection - Honest, verifiable security and privacy messaging
 *
 * Key principle: Only claim what we can prove
 * - Calculator runs client-side ✓
 * - No financial data sent to servers (for non-logged-in users) ✓
 * - Supabase has SOC 2 certification ✓
 * - Users can delete their data ✓
 */

const TrustSection = () => {
  const trustPoints = [
    {
      icon: '🔒',
      title: 'Privacy First',
      description:
        'All calculations run in your browser. Your financial numbers never leave your device.',
      highlight: 'No data sent to servers',
    },
    {
      icon: '🛡️',
      title: 'Your Data, Your Control',
      description:
        'Create an account only if you want to save your plan. Delete your data anytime with one click.',
      highlight: 'Delete anytime',
    },
    {
      icon: '🇮🇳',
      title: 'Built for India',
      description:
        'Indian inflation rates, tax rules, and market data. Not a Western calculator with ₹ symbols.',
      highlight: 'India-specific assumptions',
    },
    {
      icon: '📊',
      title: 'Transparent Methodology',
      description:
        'Our calculations use published research and historical Indian market data. No black boxes.',
      highlight: 'Open methodology',
    },
  ];

  return (
    <section className="trust-section">
      <div className="trust-container">
        <div className="trust-header">
          <h2 className="trust-title">Why Trust FINNCAL?</h2>
          <p className="trust-subtitle">
            Your financial data is sensitive. Here's how we protect it.
          </p>
        </div>

        <div className="trust-grid">
          {trustPoints.map((point, index) => (
            <div key={index} className="trust-card">
              <div className="trust-icon">{point.icon}</div>
              <h3 className="trust-card-title">{point.title}</h3>
              <p className="trust-card-description">{point.description}</p>
              <span className="trust-highlight">{point.highlight}</span>
            </div>
          ))}
        </div>

        {/* Security badges - only verifiable claims */}
        <div className="trust-badges">
          <div className="badge">
            <span className="badge-icon">🔐</span>
            <span className="badge-text">SSL Encrypted</span>
          </div>
          <div className="badge">
            <span className="badge-icon">✓</span>
            <span className="badge-text">100% Free Tools</span>
          </div>
          <div className="badge">
            <span className="badge-icon">🏦</span>
            <span className="badge-text">Secured by Supabase</span>
            <span className="badge-subtext">(SOC 2 Type 2 Certified)</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
